class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.milestones = [];
    this.lastMilestone = null;
    this.progressBar = null;
    this.labelElement = null;
  }

  connectedCallback() {
    this.initializeElements();
  }

  initializeElements() {
    this.progressBar = this.querySelector('.js-progress-bar');
    this.progressFill = this.querySelector('.js-progress-fill');
    this.labelElement = this.querySelector('.js-label');
    this.initializeMilestones();
  }

  initializeMilestones() {
    const milestoneElements = this.querySelectorAll('.js-milestone');
    this.milestones = Array.from(milestoneElements).map(el => ({
      element: el,
      amount: parseInt(el.dataset.amount) || 0,
      progressLabel: el.dataset.progressLabel || '',
      achievedLabel: el.dataset.achievedLabel || '',
      left: parseFloat(el.style.getPropertyValue('--left')) || 0
    }));

    // Find the last milestone (highest amount)
    if (this.milestones.length > 0) {
      this.lastMilestone = this.milestones.reduce((max, m) =>
        m.amount > max.amount ? m : max
      );
    }
  }

  updateProgress(cartTotalPrice) {
    // Hide progress bar if cart is empty
    if (!cartTotalPrice || cartTotalPrice === 0) {
      this.style.display = 'none';
      return;
    }

    // Show progress bar if cart has items
    this.style.display = 'block';

    // Reinitialize elements if not already initialized
    if (!this.progressFill || !this.labelElement) {
      this.initializeElements();
    }

    // Reinitialize milestones if not loaded yet
    if (this.milestones.length === 0 || !this.lastMilestone) {
      this.initializeMilestones();
    }

    if (!this.lastMilestone || this.milestones.length === 0) {
      return;
    }

    // Calculate progress percentage
    const progress = Math.min(
      (cartTotalPrice / this.lastMilestone.amount) * 100,
      100
    );

    // Update CSS variable for progress bar width
    this.style.setProperty('--progress', `${progress}%`);

    // Update progress bar fill width directly
    if (this.progressFill) {
      this.progressFill.style.width = `${progress}%`;
    }

    // Find next milestone
    const nextMilestone = this.milestones.find(m =>
      m.amount > cartTotalPrice
    ) || this.lastMilestone;

    // Check if achieved (100% progress)
    const achieved = progress >= 100;

    // Update label
    if (this.labelElement) {
      if (achieved) {
        this.labelElement.textContent = this.lastMilestone.achievedLabel;
      } else {
        const amountLeft = Math.max(0, nextMilestone.amount - cartTotalPrice);
        const amountLeftFormatted = this.formatMoney(amountLeft);
        const label = nextMilestone.progressLabel.replace(
          '[[amount_left]]',
          amountLeftFormatted
        );
        this.labelElement.textContent = label;
      }
    }

    // Update milestone states
    this.milestones.forEach(milestone => {
      const milestoneProgress = (milestone.amount / this.lastMilestone.amount) * 100;
      const isAchieved = progress >= milestoneProgress;

      milestone.element.classList.toggle('checked', isAchieved);
    });
  }

  formatMoney(cents) {
    const moneyFormat = '$';
    const formattedPrice = (cents / 100).toFixed(2);

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate != 1.0) {
      return `${formattedPrice} ${window.Shopify.currency.active}`;
    } else {
      return `$${formattedPrice}`;
    }
  }
}

if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBar);
}

document.addEventListener('DOMContentLoaded', function () {
  let selectProductVariants = document.querySelectorAll('.select-product-variant');

  if (window.location.hash === "#open-cart=1") {
    showSmallCart();
  }

  selectProductVariants.forEach(function (element) {
    element.addEventListener('click', function () {
      let variant_name = this.getAttribute('data-variant-name');
      let variant_title = this.getAttribute('data-variant-title');

      document.querySelectorAll('.variant-' + variant_name).forEach(function (item) {
        item.classList.remove('active-variant');
      });
      this.classList.add('active-variant');

      document.getElementById('current_variant_' + variant_name).textContent = variant_title;
      selectPdpVariant(variant_name, variant_title);
    });
  });

  // Only auto-select variant if there's no variant in URL
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('variant')) {
    const variant3 = [...document.querySelectorAll('[data-variant-title]')]
      .find(el => el.dataset.variantTitle === '3');

    if (variant3) {
      variant3.click();
    } else {
      // If not found, try to find and click the one with variantTitle '4'
      const variant4 = [...document.querySelectorAll('[data-variant-title]')]
        .find(el => el.dataset.variantTitle === '2');
      if (variant4) {
        variant4.click();
      }
    }
  } else {
    // If variant in URL, trigger price update for the active variant
    const activeColorElement = document.querySelector('.variant-color.active-variant');
    const activeSizeElement = document.querySelector('.variant-size.active-variant');
    
    if (activeColorElement || activeSizeElement) {
      const variantName = activeColorElement ? 'color' : 'size';
      const variantTitle = activeColorElement ? activeColorElement.dataset.variantTitle : activeSizeElement.dataset.variantTitle;
      selectPdpVariant(variantName, variantTitle);
    }
  }

  let smallCartBlockOver = document.querySelector('.small-cart-block-over');

  if (smallCartBlockOver) {
    smallCartBlockOver.addEventListener('click', closeSmallCart);
  }

  initCart();

});

function selectPdpVariant(option, value) {

  let activeColorElement = document.querySelector('.variant-color.active-variant');
  let activeSizeElement = document.querySelector('.variant-size.active-variant');

  let active_color = activeColorElement ? activeColorElement.dataset.variantTitle : null;
  let active_size = activeSizeElement ? activeSizeElement.dataset.variantTitle : null;

  let productVariantOptions = document.querySelectorAll('#product_variant_id option');

  productVariantOptions.forEach(function (option) {

    let option1 = option.dataset.option1;
    let option2 = option.dataset.option2;
    let variant_price = parseInt(option.getAttribute('data-variant-price'));
    let variant_one_time_strike_price = option.getAttribute('data-variant-strikeprice');
    let variant_compare_price = parseInt(option.getAttribute('data-variant-compare-price'));
    let available = option.getAttribute('data-variant-available');

    let active_compare_price = 0;
    if (variant_price < variant_compare_price) {
      active_compare_price = 1;
    }

    if ((option1 === active_color && option2 === active_size)
      || (option1 === active_size && option2 === active_color)
      || (active_color == null && option1 == active_size)
      || (active_size == null && option1 == active_color)
    ) {
      document.querySelector('#selected_variant_id').value = option.value;

      // Update URL to reflect selected variant
      const variantId = option.value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({ path: url.href }, '', url.href);

      const addToCartElement = document.getElementById('add_to_cart');
      //const soldOutElement = document.getElementById('sold_out');
      const soldOutNotifyAvailable = document.getElementById('notify-when-available');
      const comparePriceBlock = document.getElementById('product_compare_price_block');
      const normalPriceBlock = document.getElementById('product_normal_price_block');
      const subscribeDiscountElement = document.getElementById('subscribeDiscount');
      const subscribeDiscount = subscribeDiscountElement ? parseInt(subscribeDiscountElement.value) : 0;

      if (available == 'true') {
        addToCartElement.style.display = 'flex';
        //soldOutElement.style.display = 'none';
        soldOutNotifyAvailable.style.display = 'none';
      } else {
        //soldOutElement.style.display = 'flex';
        addToCartElement.style.display = 'none';
        soldOutNotifyAvailable.style.display = 'block';
      }
      let priceWithDiscountFormated = '';
      if (active_compare_price == 1) {
        comparePriceBlock.style.display = 'block';
        normalPriceBlock.style.display = 'none';

        document.getElementById('product_normal_price').textContent = formatProductPrice(variant_price);
        document.getElementById('product_normal_price_compare').textContent = formatProductPrice(variant_price);
        document.getElementById('product_price_saving').textContent = formatProductPrice(variant_compare_price - variant_price);
        document.getElementById('product_compare_price').textContent = formatProductPrice(variant_compare_price);

      } else {
        comparePriceBlock.style.display = 'none';
        normalPriceBlock.style.display = 'block';
        document.getElementById('product_normal_price').textContent = formatProductPrice(variant_price);
        document.getElementById('product_normal_price_compare').textContent = formatProductPrice(variant_price);

        //pdp.one_time_strike_price
        if ($('span[skio-onetime-price]').length > 0) {
          if (variant_one_time_strike_price != '') {
            $('span[skio-onetime-price]').html(`<span class="line-through text-black pr-1">` + formatProductPrice(variant_price) + `</span><span class="text-[#E60000]">${variant_one_time_strike_price}</span>`);
          } else {
            $('span[skio-onetime-price]').text(formatProductPrice(variant_price));
          }
        }

        if (subscribeDiscount > 0 && $('span[skio-subscription-price]').length > 0) {
          let oneTimeFormatedPrice = formatProductPrice(variant_price);
          let subscribeDiscountNumber = subscribeDiscount / 100;
          let priceWithDiscount = variant_price * subscribeDiscountNumber;
          priceWithDiscountFormated = formatProductPrice(variant_price - priceWithDiscount);
          let subscribePriceHtml = `<span class="line-through text-black pr-1">${oneTimeFormatedPrice}</span><span class="text-[#E60000]">${priceWithDiscountFormated}</span>`;

          $('span[skio-subscription-price]').html(subscribePriceHtml);
        }



      }
      // Update button price based on subscription or one-time purchase
      if ($('.subscribe-container input:checked').length > 0 && $('.subscribe-container input:checked').val() != '' && priceWithDiscountFormated != '') {
        // Subscription is selected - use subscribe discount price
        document.getElementById('product_price_in_button').textContent = priceWithDiscountFormated;
      } else if (variant_one_time_strike_price != '' && variant_one_time_strike_price != null) {
        // One-time purchase with strike price - use strike price
        document.getElementById('product_price_in_button').textContent = variant_one_time_strike_price;
      } else {
        // Default - use base variant price
        document.getElementById('product_price_in_button').textContent = formatProductPrice(variant_price);
      }

      selectImageOnGalleryForVariant(option1);
    }
  });
}

function selectImageOnGalleryForVariant(active_color) {
  // Check if Swiper gallery exists (new implementation)
  if (window.swiperGalleryLarge) {
    // Find the matching thumbnail index based on variant option
    const thumbnails = document.querySelectorAll('.gallery-tmb');
    let matchingIndex = -1;

    thumbnails.forEach((thumb, index) => {
      const thumbOption1 = thumb.dataset.imgVariantOption1;
      const thumbOption2 = thumb.dataset.imgVariantOption2;

      // Match based on either option1 or option2
      if (thumbOption1 === active_color || thumbOption2 === active_color) {
        matchingIndex = index;
      }
    });

    // If a matching image is found, slide to it
    if (matchingIndex !== -1) {
      window.swiperGalleryLarge.slideTo(matchingIndex);
    }
  } else {
    // Fallback to old implementation (clicking thumbnails)
    const element = document.querySelector(`.gallery-tmb[data-img-variant-option1="${active_color}"]`);
    if (element) {
      element.click();
    }
  }
}

function updateProductQuantity(type, id) {
  let quantity = parseInt(document.getElementById('quantity_' + id).value);
  let new_quantity = quantity;
  if (type == 'plus') {
    new_quantity = quantity + 1;
  }
  if (type == 'minus') {
    if (quantity > 1) {
      new_quantity = quantity - 1;
    }
  }

  document.getElementById('quantity_' + id).value = new_quantity;
}
/* for showing small cart modal */
function showSmallCart() {
  closeSearchModal();
  closeMainNavigationMobile();
  const smallCartBlockOver = document.querySelector('.small-cart-block-over');
  const smallCartBlock = document.querySelector('.small-cart-block');
  const smallCartSubtotal = document.querySelector('.small-cart-subtotal');

  if (smallCartBlockOver && smallCartBlock) {
    smallCartBlockOver.style.display = 'block';
    document.body.style.overflow = 'hidden';


    smallCartBlock.style.transition = 'right 700ms';
    smallCartBlock.style.right = '0';

    setTimeout(function () {
      smallCartSubtotal.style.opacity = '1';
      smallCartSubtotal.style.display = 'block';
    }, 700);
  }

}
/* for closing small cart modal */
function closeSmallCart() {
  const smallCartBlockOver = document.querySelector('.small-cart-block-over');
  const smallCartBlock = document.querySelector('.small-cart-block');
  const smallCartSubtotal = document.querySelector('.small-cart-subtotal');

  if (smallCartBlockOver && smallCartBlock) {
    smallCartBlockOver.style.display = 'none';
    smallCartSubtotal.style.display = 'none';
    document.body.style.overflow = 'auto';


    smallCartSubtotal.style.opacity = '0';

    smallCartBlock.style.transition = 'right 700ms';
    smallCartBlock.style.right = '-700px';
  }
}
/* for button quick add to cart on product grid hover */
function quickAddItemToCart(variant_id, custom_qty) {
  if (variant_id) {
    let data = {};
    if (custom_qty == null) {
      data = {
        id: variant_id,
        quantity: 1
      };
    } else {
      let qty = $(`#quantity_variant_also_like_${variant_id}`).val();
      data = {
        id: variant_id,
        quantity: qty
      };
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

    xhr.onload = function () {
      if (xhr.status === 200) {
        initCart();
        showSmallCart();
      } else {
        const errorResponse = JSON.parse(xhr.responseText);
        alert(errorResponse.message + '\r\n' + errorResponse.description);
      }
    };

    xhr.onerror = function (error) {
      console.error('An error occurred:', error);
    };

    xhr.send(JSON.stringify(data));
  }
}

function sellingPlanAddItemToCart(variant_id, selling_plan_id) {
  if (variant_id) {

    checkSellingProductInCart();

    setTimeout(function () {
      let data = {};

      data = {
        id: variant_id,
        quantity: 1,
        selling_plan: selling_plan_id,
        properties: {
          '_inveterate_subscription': true
        }
      };


      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

      xhr.onload = function () {
        if (xhr.status === 200) {
          initCart();
          showSmallCart();
        } else {
          const errorResponse = JSON.parse(xhr.responseText);
          alert(errorResponse.message + '\r\n' + errorResponse.description);
        }
      };

      xhr.onerror = function (error) {
        console.error('An error occurred:', error);
      };

      xhr.send(JSON.stringify(data));
    }, 1000);
  }
}

function checkSellingProductInCart() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (data.item_count > 0) {
        for (let i = 0; i < data.item_count; i++) {
          if (data.items[i] && data.items[i].id) {
            if (typeof data.items[i].properties._inveterate_subscription != 'undefined') {
              if (data.items[i].properties._inveterate_subscription == true) {
                deleteProductFromCart(data.items[i].id);
              }
            }
          }
        }
      }
    })
    .catch(error => {
      alert('Error: ' + error.message);
    });
}

function addItemToCartOnPdp() {
  const qty = parseInt(document.getElementById('quantity_pdp_page').value);
  const variant_id = document.getElementById('selected_variant_id').value;

  if (variant_id && qty > 0) {

    let data = {
      id: variant_id,
      quantity: qty
    };

    let selling_plan_id = '';
    if ($('.subscribe-container input:checked').length > 0 && $('.subscribe-container input:checked').val() != '') {
      selling_plan_id = $('select.plan-selector option:selected').val()
    }

    if (selling_plan_id != '') {
      data = {
        id: variant_id,
        quantity: qty,
        selling_plan: selling_plan_id
      };
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        initCart();
        showSmallCart();
      },
      error: function (error) {
        alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
      }
    });

  }
}

function addItemToCartOnSingeSection() {
  const qty = parseInt(document.getElementById('quantity_pdp_page').value);
  const variant_id = document.getElementById('product_variant_id').value;


  if (variant_id && qty > 0) {

    let data = {
      id: variant_id,
      quantity: qty
    };

    const sellingPlanSelected = document.querySelector(`#skio-selling-plan-selected-${variant_id}`);
    const sellingPlanSelectedValue = document.querySelector(`#skio-selling-plan-selected-value-${variant_id}`);

    if (sellingPlanSelected != null && sellingPlanSelected.checked) {
      const selling_plan_id = sellingPlanSelectedValue.value;

      if (selling_plan_id !== '' && parseInt(selling_plan_id) > 0) {
        data = {
          id: variant_id,
          quantity: qty,
          selling_plan: selling_plan_id
        };
      }
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

    xhr.onload = function () {
      if (xhr.status === 200) {
        initCart();
        showSmallCart();
      } else {
        const errorResponse = JSON.parse(xhr.responseText);
        alert(errorResponse.message + '\r\n' + errorResponse.description);
      }
    };

    xhr.onerror = function (error) {
      console.error('An error occurred:', error);
    };

    xhr.send(JSON.stringify(data));
  }
}

function updateCartProgressBars(cartTotalPrice) {
  const progressBars = document.querySelectorAll('cart-progress-bar');
  progressBars.forEach(bar => {
    if (bar && typeof bar.updateProgress === 'function') {
      bar.updateProgress(cartTotalPrice);
    }
  });
}

function initCart() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {

      let item_counts_in_cart = data.item_count;
      let text_items = '';
      if (item_counts_in_cart > 1) {
        text_items = `(${item_counts_in_cart} items)`;
      } else {
        text_items = `(${item_counts_in_cart} item)`;
      }
      document.getElementById('total_save_sum').style.display = 'none';
      if (item_counts_in_cart > 0) {
        document.getElementById('no_items_in_small_cart').style.display = 'none';
        document.getElementById('small_products_list').style.display = 'none';
        document.getElementById('small_cart_loading').style.display = 'flex';
        document.getElementById('checkout_buttons_block').style.display = 'flex';
        document.getElementById('checkout_buttons_block-disabled').style.display = 'none';
        document.getElementById('small_cart_count_items').innerText = text_items;
        document.getElementById('products-count-header').innerText = item_counts_in_cart;
        document.getElementById('form-add-notes-to-order').style.display = 'inline';
        document.getElementById('cart-related-products').style.display = 'inline';
        document.getElementById('small_cart_count_items').style.display = 'inline';
        //document.querySelector('.small-cart-subtotal').style.display = 'block';
      } else {
        document.getElementById('small_products_list').style.display = 'none';
        document.getElementById('small_cart_loading').style.display = 'none';
        document.getElementById('checkout_buttons_block').style.display = 'none';
        document.getElementById('checkout_buttons_block-disabled').style.display = 'flex';
        document.getElementById('no_items_in_small_cart').style.display = 'block';
        document.getElementById('small_cart_count_items').innerText = '(0 items)';
        document.getElementById('small_cart_total').innerText = '$0.00';
        //  document.getElementById('small_cart_count_items').style.display = 'none';
        document.getElementById('form-add-notes-to-order').style.display = 'none';
        document.getElementById('cart-related-products').style.display = 'none';
        document.getElementById('products-count-header').innerText = '';
        //document.querySelector('.small-cart-subtotal').style.display = 'none';
      }

      updateCartProgressBars(data.total_price);

      loadCart();
    })
    .catch(error => {
      alert('Error: ' + error.message);
    });
}

function subscribeProductFromCart(item_key, key_id, variant_id) {
  const selling_plan_id = $(`#subscribe-and-save-product-selling-plan-${key_id}`).val();
  if (selling_plan_id && selling_plan_id != '') {
    sellingPlanAddItemToCart(variant_id, selling_plan_id);
    deleteProductFromCart(`${item_key}`);
    $(`#subscribe-and-save-btn-${key_id}`).html('<span class="text-sm text-secondary-caramel w-full text-center h-[42px] flex items-center justify-center">Please wait...</span>');
  }
}

function loadCart() {

  let bundleProductIds = [7385675301057, 7385674055873, 10596912038081, 10095977070785, 7583142543553, 10095976972481, 10095976743105, 10778723156161, 10778719158465, 10778724401345, 10778710933697];
  let smallCartHtmlTemplate = smallCartItemBundleTemplate;
  let productImagesHtml = '';
  let productImagesHtmlSubscribe = '';
  let bundleTotalPrice = 0;
  let bundleTotalPriceSubscribe = 0;
  let bundleDeleteKeys = '';
  let bundleDeleteKeysSubscribe = '';
  let bundleTitle = '';
  let bundleTitleSubscribe = '';
  let bundleSellingPLanName = '';

  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      let discount_enabled = 0;
      let saved_money = 0;
      let item_count = data.item_count;
      let original_total_price = formatProductPrice(data.original_total_price);
      let total_price = formatProductPrice(data.total_price);
      let cart_has_subscribe_product = 0;
      let add_gift_product = 0;
      let gift_product_already_added = 0;
      let product_with_gift_in_cart = 0;

      if (data.original_total_price > data.total_price) {
        discount_enabled = 1;
        saved_money = data.original_total_price - data.total_price;
        saved_money = formatProductPrice(saved_money);
      }

      if (item_count > 0) {
        let cart_list = [];
        let cart_has_bundle = 0;
        let cart_has_bundle_subscribe = 0;

        for (let i = 0; i < item_count; i++) {
          if (data.items[i] && data.items[i].id) {

            let html = '';
            let cartItemTemplate = smallCartItemTemplate;
            let product_title = data.items[i].product_title;
            let quantity = data.items[i].quantity;
            let item_id = data.items[i].id;
            let key = data.items[i].key;
            let product_handle = data.items[i].handle;
            let real_price = formatProductPrice(data.items[i].price);
            let line_price = formatProductPrice(data.items[i].final_price);
            let product_url = data.items[i].url;
            let image_url = data.items[i].image;
            let variants = data.items[i].variant_options;
            let variant_title = data.items[i].variant_title;
            let selling_plan_name = '';
            let product_id = data.items[i].product_id;
            let hide_change_quantity = 0;
            let this_is_gift_product = 0;
            let showSubscribeAndSaveBtn = 0;

            let cartContainBundleProducts = 0;


            if (bundleProductIds.includes(product_id)) {
              cartContainBundleProducts = 1;

              if (typeof data.items[i].selling_plan_allocation == 'undefined') {
                cart_has_bundle = 1;
              } else {
                cart_has_bundle_subscribe = 1;
              }
            }

            if (typeof data.items[i].selling_plan_allocation == 'undefined') {
              showSubscribeAndSaveBtn = 1;
            }

            if (data.items[i].price != data.items[i].final_price && data.items[i].final_price == 0) {
              line_price = '<span style="color: rgb(230, 0, 0);">Free</span>';
            }

            /*GIFT PRODUCT CHECKING*/
            if (enableGiftProduct == 'true') {

              if (giftProductsList.includes(product_id) || enableAddGiftProductForAll == 'true') {
                product_with_gift_in_cart = 1;
                if (gift_product_already_added == 0) {
                  add_gift_product = 1;
                }
              }
              if (item_id == giftProductID) {
                this_is_gift_product = 1;
                gift_product_already_added = 1;
                add_gift_product = 0;
              }
              if (enableMinPriceFunction == 'true') {
                minPriceSum = minPriceSum * 100;
                if (data.total_price < minPriceSum) {
                  this_is_gift_product = 0;
                  product_with_gift_in_cart = 0;
                  gift_product_already_added = 0;
                  add_gift_product = 0;
                }

              }

              if (enableCheckTime == 'true') {
                let res_check_date = compareDates(giftCurrentDate, giftDateStart, giftDateEnd);
                // if(res_check_date == 0){
                //     this_is_gift_product = 0;
                //     product_with_gift_in_cart = 0;
                //     gift_product_already_added = 0;
                //     add_gift_product = 0;
                // }

              }

            }

            if (this_is_gift_product == 1) {
              hide_change_quantity = 1;
            }

            if (variant_title == null) {
              variant_title = '';
            } else {
              variant_title = `Pack: ${variant_title}`;
            }

            if (data.items[i].selling_plan_allocation) {
              let selling_plan_allocation = data.items[i].selling_plan_allocation;
              selling_plan_name = selling_plan_allocation.selling_plan.name;
            }

            let hide_change_quantity_selling_plan = 0;
            if (typeof data.items[i].properties._inveterate_subscription != 'undefined') {
              if (data.items[i].properties._inveterate_subscription == true) {
                hide_change_quantity_selling_plan = 1;
                variant_title = '';
              }
            }

            if (cartContainBundleProducts == 1) {
              cartItemTemplate = cartItemTemplate.replace('[hide_product_on_cart]', 'style="display:none"');

              if (data.items[i].selling_plan_allocation) {
                productImagesHtmlSubscribe = productImagesHtmlSubscribe + `<img src="${image_url}" />`;
                bundleTotalPriceSubscribe = bundleTotalPriceSubscribe + data.items[i].final_price;
                if (bundleDeleteKeysSubscribe != '') {
                  bundleDeleteKeysSubscribe = bundleDeleteKeysSubscribe + ',' + key;
                } else {
                  bundleDeleteKeysSubscribe = bundleDeleteKeysSubscribe + key;
                }
                if (bundleTitleSubscribe != '') {
                  bundleTitleSubscribe = bundleTitleSubscribe + ', ' + product_title;
                } else {
                  bundleTitleSubscribe = bundleTitleSubscribe + product_title;
                }
                bundleSellingPLanName = selling_plan_name;
              } else {
                productImagesHtml = productImagesHtml + `<img src="${image_url}" />`;
                bundleTotalPrice = bundleTotalPrice + data.items[i].final_price;
                if (bundleDeleteKeys != '') {
                  bundleDeleteKeys = bundleDeleteKeys + ',' + key;
                } else {
                  bundleDeleteKeys = bundleDeleteKeys + key;
                }
                if (bundleTitle != '') {
                  bundleTitle = bundleTitle + ', ' + product_title;
                } else {
                  bundleTitle = bundleTitle + product_title;
                }
              }
            } else {
              cartItemTemplate = cartItemTemplate.replace('[hide_product_on_cart]', '');
            }

            cartItemTemplate = cartItemTemplate.replace('[product_url]', product_url);
            cartItemTemplate = cartItemTemplate.replace('[product_image]', image_url);
            cartItemTemplate = cartItemTemplate.replace('[product_name]', product_title);
            cartItemTemplate = cartItemTemplate.replace('[variant_name]', variant_title);
            cartItemTemplate = cartItemTemplate.replace('[variant_id]', item_id);
            cartItemTemplate = cartItemTemplate.replace('[variant_id_1]', item_id);
            cartItemTemplate = cartItemTemplate.replace('[delete_key_id]', key);
            cartItemTemplate = cartItemTemplate.replace('[product_quantity]', quantity);
            cartItemTemplate = cartItemTemplate.replace('[quantity_variant_id]', item_id);
            cartItemTemplate = cartItemTemplate.replace('[update_variant_id_1]', item_id);
            cartItemTemplate = cartItemTemplate.replace('[update_variant_id_2]', item_id);
            cartItemTemplate = cartItemTemplate.replace('[variant_id_3]', item_id);

            cartItemTemplate = cartItemTemplate.replace('[selling_plan_name]', selling_plan_name);
            cartItemTemplate = cartItemTemplate.replace('[variant_id_for_selling_plan]', key);

            const key_id = key.replace(':', "_");
            cartItemTemplate = cartItemTemplate.replace('[key_id]', key_id);
            cartItemTemplate = cartItemTemplate.replace('[key_id_1]', key_id);
            cartItemTemplate = cartItemTemplate.replace('[key_id_2]', key_id);

            if (hide_change_quantity_selling_plan == 1) {
              cartItemTemplate = cartItemTemplate.replace('[hide_quantity]', 'opacity:0;');
            } else {
              cartItemTemplate = cartItemTemplate.replace('[hide_quantity]', '');
            }

            if (hide_change_quantity_selling_plan == 0) {
              if (hide_change_quantity == 1) {
                cartItemTemplate = cartItemTemplate.replace('[hide_quantity]', 'opacity:0;');
                cartItemTemplate = cartItemTemplate.replace('[hide_delete]', 'opacity:0;');
              } else {
                cartItemTemplate = cartItemTemplate.replace('[hide_quantity]', '');
                cartItemTemplate = cartItemTemplate.replace('[hide_delete]', '');
              }
            }

            cartItemTemplate = cartItemTemplate.replace('[price]', line_price);

            let final_sale = 0;
            fetch('/products/' + data.items[i].handle + '.js')
              .then(response => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response.json();
              })
              .then(product_data => {


                if (product_data.selling_plan_groups.length == 1 && showSubscribeAndSaveBtn == 1) {
                  $(`#subscribe-and-save-btn-${key_id}`).show();
                  if (product_data.selling_plan_groups[0].selling_plans[0].id) {
                    const selling_plan_id = product_data.selling_plan_groups[0].selling_plans[0].id;
                    $(`#subscribe-and-save-product-selling-plan-${key_id}`).val(selling_plan_id);
                  }
                }

                if (product_data.tags.includes('Final Sale')) {
                  final_sale = 1;
                }
                if (product_data.variants.length > 0) {
                  product_data.variants.forEach(async (pr_variant) => {
                    if (pr_variant.id == item_id) {
                      if (pr_variant.compare_at_price > 0) {
                        let old_price = formatProductPrice(pr_variant.compare_at_price);
                        let element = document.getElementById(`variant_price_${item_id}`);
                        let checkComparePriceInConde = element.querySelectorAll('span.old-price-small-cart');

                        if (element) {
                          element.style.color = '#E60000';

                          let oldPriceSpan = '';
                          oldPriceSpan = document.createElement('span');
                          if (checkComparePriceInConde.length == 0) {
                            oldPriceSpan.className = 'old-price-small-cart';
                            oldPriceSpan.textContent = old_price;

                            element.insertBefore(oldPriceSpan, element.firstChild);
                          }
                        }
                      }
                    }
                  });
                }

                if (final_sale == 1) {
                  let element = document.getElementById(`final_sale_${item_id}`);
                  if (element) {
                    element.textContent = 'Final Sale';
                  }
                }
              });


            html = cartItemTemplate;
            cart_list.push(html);
          }
        }

        if (cart_has_bundle == 1) {
          let htmlBundle = smallCartHtmlTemplate;
          htmlBundle = htmlBundle.replace('[product_images]', productImagesHtml);
          htmlBundle = htmlBundle.replace('[price]', formatProductPrice(bundleTotalPrice));
          htmlBundle = htmlBundle.replace('[delete_keys]', bundleDeleteKeys);
          htmlBundle = htmlBundle.replace('[bundle_title]', bundleTitle);
          htmlBundle = htmlBundle.replace('[subscribeTitle]', '');
          htmlBundle = htmlBundle.replace('[subscribeClassTitle]', '');
          htmlBundle = htmlBundle.replace('[subscribeClassTitle1]', '');
          htmlBundle = htmlBundle.replace('[sellingPlanName]', '');

          cart_list.unshift(htmlBundle);
        }
        if (cart_has_bundle_subscribe == 1) {
          let htmlBundleSubscribe = smallCartHtmlTemplate;
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[product_images]', productImagesHtmlSubscribe);
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[price]', formatProductPrice(bundleTotalPriceSubscribe));
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[delete_keys]', bundleDeleteKeysSubscribe);
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[bundle_title]', bundleTitleSubscribe);
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[subscribeTitle]', ' - Subscription');
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[subscribeClassTitle]', 'Subscribe');
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[subscribeClassTitle1]', 'Subscribe');
          htmlBundleSubscribe = htmlBundleSubscribe.replace('[sellingPlanName]', bundleSellingPLanName);


          cart_list.unshift(htmlBundleSubscribe);
        }

        /*GIFT PRODUCT ACTIONS*/
        if (add_gift_product == 1) {
          addGiftProductToCart();
        }
        if (product_with_gift_in_cart == 0 && gift_product_already_added == 1) {
          deleteGiftProductFromCart();
        }

        if (discount_enabled == 1) {
          document.getElementById('total_save_sum').style.display = 'block';
          document.querySelector('#total_save_sum span').innerHTML = saved_money;
          document.getElementById('small_cart_total').innerHTML = `<span class="old-total-price-small-cart">${original_total_price}</span> <span style="color:red">${total_price}</span>`;
        } else {
          document.getElementById('total_save_sum').style.display = 'none';
          document.getElementById('small_cart_total').textContent = total_price;
        }
        document.getElementById('small_products_list').innerHTML = cart_list.join('');
        document.getElementById('small_products_list').style.display = 'block';
        document.getElementById('small_cart_loading').style.display = 'none';

        updateCartProgressBars(data.total_price);
      } else {
        updateCartProgressBars(0);
      }
    })
    .catch(error => {
      alert('Error: ' + error.message);
    });
}

function addGiftProductToCart() {
  if (giftProductID && giftProductID > 0) {
    quickAddItemToCart(giftProductID);
  }
}

function deleteGiftProductFromCart() {
  if (giftProductID && giftProductID > 0) {
    deleteProductFromCart(giftProductID);
  }
}

function deleteBundleProducts(delete_keys, subscribeClassTitle) {
  let deleteKeysArr = delete_keys.split(',');
  let updates = {};

  deleteKeysArr.forEach(function (key_id) {
    updates[key_id] = 0;
  });

  let data = {
    updates: updates
  };

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    async: false,
    success: function (data) {
      initCart();
    }

  });

}


function goToCheckoutFromCart() {

  const giftMessage = document.getElementById('small_cart_gift_message').value;
  const giftFrom = document.getElementById('small_cart_gift_from').value;

  if (giftMessage !== '') {
    const data = {
      'note': `Message: ${giftMessage} | From: ${giftFrom}`
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch('/cart/update.js', requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        alert(error.message + '\r\n' + error.description);
      });
  } else {
    window.location.href = '/checkout';
  }

}

function updateProductQuantityAlsoLike(variant_id, type) {
  let quantity_input = document.getElementById('quantity_variant_also_like_' + variant_id);
  let current_quantity = parseInt(quantity_input.value);
  let new_quantity = current_quantity;

  if (type == 'plus') {
    new_quantity = current_quantity + 1;
  }

  if (type == 'minus') {
    new_quantity = current_quantity - 1;
    if (new_quantity < 1) {
      new_quantity = 1;
    }
  }

  quantity_input.value = new_quantity;
}

function updateProductQuantityOnCart(variant_id, type) {
  let current_quantity = parseInt(document.getElementById('quantity_variant_' + variant_id).value);
  let new_quantity = current_quantity;

  if (type == 'plus') {
    new_quantity = current_quantity + 1;
  }

  if (type == 'minus') {
    new_quantity = current_quantity - 1;
  }

  let data = {
    'id': variant_id,
    'quantity': new_quantity
  };

  postAjax('/cart/change.js', data, function (data) {
    initCart();
  });
}

function deleteProductFromCart(key_id) {
  let data = {
    'id': key_id,
    'quantity': 0
  };

  postAjax('/cart/change.js', data, function (data) {
    initCart();
  });
}

function postAjax(url, data, success) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
    function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState > 3 && xhr.status == 200) { success(xhr.responseText); }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

function formatProductPrice(product_price) {
  let money_format = '$';
  let formattedPrice = product_price / 100;

  formattedPrice = formattedPrice.toFixed(2);

  if (Shopify.currency.rate != 1.0) {
    formattedPrice = `${formattedPrice} ${Shopify.currency.active}`;
  } else {
    formattedPrice = `$${formattedPrice}`;
  }

  return formattedPrice;
}

function updateProductPriceDisplay(price, subscribe_plan, subscribe_price) {
  // const subscribeComparePrice = document.getElementById('subscribe_compare_price');
  // const productNormalPrice = document.getElementById('product_normal_price');
  //
  // console.log('subscribeComparePrice - ', subscribeComparePrice)
  //
  // if(subscribeComparePrice != null && productNormalPrice != null) {
  //     if (subscribe_plan === 1) {
  //         subscribeComparePrice.style.display = 'inline-block';
  //         subscribeComparePrice.textContent = price;
  //         productNormalPrice.textContent = subscribe_price;
  //         productNormalPrice.classList.add('text-[#E60000]');
  //         document.getElementById('product_price_in_button').textContent = subscribe_price;
  //     } else {
  //         subscribeComparePrice.style.display = 'none';
  //         productNormalPrice.textContent = price;
  //         productNormalPrice.classList.remove('text-[#E60000]');
  //         document.getElementById('product_price_in_button').textContent = price;
  //     }
  // }
  let selectProductVariants = document.querySelectorAll('.select-product-variant');
  selectProductVariants.forEach(function (element) {
    if (element.classList.contains('active-variant')) {
      let variant_name = element.getAttribute('data-variant-name');
      let variant_title = element.getAttribute('data-variant-title');
      selectPdpVariant(variant_name, variant_title);
    }
  });
}

function compareDates(d_now, d1, d2) {
  let date1 = new Date(d_now).getTime();
  let date2 = new Date(d1).getTime();
  let date3 = new Date(d2).getTime();

  if (date1 > date2 && date1 < date3) {
    return 1;
  }
  return 0;
}
